import { userConstants } from "../../constant";

const initialState = {
  visible: false,
  products: [],
};

export function upsellPopup(state = initialState, action) {
  switch (action.type) {
    case userConstants.SHOW_UPSELL_POPUP:
      return { visible: true, products: action.payload };
    case userConstants.HIDE_UPSELL_POPUP:
      return { visible: false, products: [] };
    default:
      return state;
  }
}
